/** removes require attribute from hidden fields **/

const hiddenContainerInputs = document.querySelector('.require-fields')
const requiredFields = document.querySelectorAll('[data-required]')

var observer = new MutationObserver((event) => {
    if (hiddenContainerInputs.classList.contains('hidden')) {
        toggleRequired(false)
    } else {
        toggleRequired(true)
    }
})

if (hiddenContainerInputs !== null) {
    observer.observe(hiddenContainerInputs, {
        attributes: true, attributeFilter: ['class']
    })
    
    function toggleRequired(isRequired = false) {
        requiredFields.forEach(field => {
            if (isRequired) {
                field.setAttribute("required", true)
                let fieldLabel = document.querySelector('label[for='+field.id+']')
                fieldLabel.innerText = fieldLabel.innerText + ' *'
            } else {
                field.removeAttribute('required')
            }
        })
    }
    toggleRequired(!hiddenContainerInputs.classList.contains('hidden'))
}